import { render, staticRenderFns } from "./PVC.vue?vue&type=template&id=6e1484e5&scoped=true&"
import script from "./PVC.vue?vue&type=script&lang=js&"
export * from "./PVC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e1484e5",
  null
  
)

export default component.exports